import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=11ea5562&"
import script from "./color-picker.vue?vue&type=script&lang=js&"
export * from "./color-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ea5562')) {
      api.createRecord('11ea5562', component.options)
    } else {
      api.reload('11ea5562', component.options)
    }
    module.hot.accept("./color-picker.vue?vue&type=template&id=11ea5562&", function () {
      api.rerender('11ea5562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/color-picker/color-picker.vue"
export default component.exports